import Link from "next/link";

import styles from "~/components/Faq/FaqPillButton.module.scss";

const FaqPillButton = ({
  setSelectedPill,
  setSearch,
  button,
  index,
  selectedPill,
  pillButtonWrapperRef,
  setHideUnselectedState,
}) => {
  return (
    <Link
      href={selectedPill ? `${button.value}` : `/faq/${button.value}`}
      key={index}
      onClick={() => {
        setSelectedPill(button.label);
        setSearch("");
        setHideUnselectedState(true);
        pillButtonWrapperRef.current.scrollLeft = 0;
      }}
      className={`${styles["FaqPillButton"]} ${
        selectedPill?.label === button.label && styles["--selected"]
      }`}
    >
      {button.label}
    </Link>
  );
};

export default FaqPillButton;
